import type { FC } from "react"

import { useTranslation } from "react-i18next"
import { useRecoilState, useRecoilValue } from "recoil"

import {
  designLocalState,
  homeownerRebateValidState,
} from "~/containers/Proposal/state/designs/design-state"

import { Card, CardsContainer } from "./styles"
import { REBATES } from "./utils"

const Rebates: FC<{ disableCards: boolean }> = ({ disableCards }) => {
  const [local, setLocal] = useRecoilState(designLocalState)
  const { t } = useTranslation()
  const homeownerRebateValid = useRecoilValue(homeownerRebateValidState)

  return (
    <CardsContainer>
      {REBATES.map(([toggleKey, valueKey, translationKey]) => (
        <Card
          invalid={toggleKey === `homeownerRebate` && !homeownerRebateValid}
          key={toggleKey}
          id={toggleKey}
          title={`${t(translationKey)}`}
          toggle={() =>
            setLocal((c) => ({
              ...c,
              [toggleKey]: !local[toggleKey],
              [valueKey]: 0,
            }))
          }
          selected={!!local[toggleKey]}
          onChange={(e) => {
            setLocal((c) => ({
              ...c,
              [valueKey]: e.target.value === `` ? 0 : parseFloat(e.target.value),
              [toggleKey]: e.target.value !== `` && e.target.value !== `0`,
            }))
          }}
          value={local[valueKey] ? parseFloat(`${local[valueKey]}`) : 0}
          disabled={disableCards}
        />
      ))}
    </CardsContainer>
  )
}

export default Rebates
